// All modules that are imported here will be included to this pack only
// and reused in other packs (they won't be duplicated in each pack)

import 'normalize.css'
import 'font-awesome/scss/font-awesome'
import 'core-js/fn/array/from'
import 'core-js/fn/array/includes'
import 'core-js/fn/object/keys'
import 'core-js/fn/object/entries'
import 'core-js/fn/object/values'
import 'core-js/fn/promise'
import 'core-js/fn/symbol'
import 'init/i18n'
import 'whatwg-fetch'
import 'styleguide/all'

import LanguageSelector from 'core/components/language_selector'
import LocaleService from 'core/services/locale_service'
import Location from 'core/models/location'

Location.getCurrent().then(location => {
  LocaleService.autoSwitchToLocale(location.getLocale())
  LanguageSelector.initialize(location)
})

import _ from 'underscore'
window._ = _

import $ from 'jquery'
window.$ = $
window.jQuery = $

const { gon } = window

import '@waze/cookie_consent/dist/index.css'
import { initialize } from '@waze/cookie_consent'
if (gon != null && !gon.disableCookieConsent) {
  initialize()
}

// TODO: remove W from global scope
if (window.W == null) {
  window.W = {}
}

import installAjaxPrefilter from 'core/ajax-prefilter'
installAjaxPrefilter()

import installFormHelper from 'core/form-helper'
installFormHelper()

import StickyBar from 'styleguide/components/sticky-bar'
StickyBar.initialize()

import Header from 'core/components/header'
Header.initialize()

import { loadFlashFromQueryParam } from 'core/components/flash'
loadFlashFromQueryParam()

import ShareButton from 'core/components/share_button'
ShareButton.initialize()

import initializeEventReporter from 'core/services/event_reporter'
initializeEventReporter()

import 'quick-win/common/js/header'
import 'quick-win/common/js/footer'
import 'download_app_banner'
